import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';
import { formatCount, getCategoryName } from '@/utils/video';

export default function LatestUploads() {
  const latest = [...videos]
    .sort((a, b) => (a.publishDate < b.publishDate ? 1 : -1))
    .slice(0, 6);

  const hot = [...videos].sort((a, b) => b.plays - a.plays).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* 最新上传 */}
        <div className="lg:col-span-2">
          <div className="flex items-end justify-between mb-6">
            <div>
              <h2 className="text-2xl md:text-3xl font-black text-foreground-950">最新上传</h2>
              <p className="text-sm text-foreground-500 mt-1.5">创作者刚刚发布的新鲜内容</p>
            </div>
          </div>

          <div className="space-y-3">
            {latest.map((v) => (
              <Link
                key={v.id}
                to={`/detail/${v.id}`}
                className="group flex gap-4 p-3 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
              >
                <div className="relative w-32 md:w-44 h-20 md:h-24 rounded-md overflow-hidden bg-secondary-100 shrink-0">
                  <img
                    src={v.cover}
                    alt={`${v.title} - 抖音短视频`}
                    title={`${v.title} - 抖音短视频`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute bottom-1 right-1 px-1.5 py-0.5 rounded bg-foreground-950/60 text-background-50 text-[11px] font-label">
                    {v.duration}
                  </span>
                </div>
                <div className="flex-1 min-w-0 py-0.5">
                  <h3 className="text-sm md:text-base font-medium text-foreground-950 leading-snug line-clamp-2">
                    {v.title}
                  </h3>
                  <div className="mt-2 flex items-center flex-wrap gap-x-4 gap-y-1 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-user-3-line"></i>
                      {v.author}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-play-circle-line"></i>
                      {formatCount(v.plays)}
                    </span>
                    <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800 text-[11px]">
                      {getCategoryName(v.category)}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        {/* 实时热榜 */}
        <aside className="lg:col-span-1">
          <div className="sticky top-20 rounded-lg bg-background-50 border border-background-200/70 p-5">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
                <i className="ri-fire-line text-lg"></i>
              </span>
              <h3 className="text-lg font-bold text-foreground-950">实时热榜</h3>
            </div>
            <ol className="space-y-3">
              {hot.map((v, i) => (
                <li key={v.id}>
                  <Link to={`/detail/${v.id}`} className="flex items-start gap-3 group cursor-pointer">
                    <span
                      className={`w-5 h-5 rounded text-xs font-bold flex items-center justify-center shrink-0 mt-0.5 ${
                        i < 3 ? 'bg-primary-500 text-background-50' : 'bg-secondary-100 text-secondary-700'
                      }`}
                    >
                      {i + 1}
                    </span>
                    <div className="min-w-0">
                      <p className="text-sm text-foreground-800 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                        {v.title}
                      </p>
                      <p className="text-xs text-foreground-400 mt-0.5 font-label">
                        {formatCount(v.plays)} 次播放
                      </p>
                    </div>
                  </Link>
                </li>
              ))}
            </ol>
          </div>
        </aside>
      </div>
    </section>
  );
}